<!-- 活动页面 -->
<template>
  <div class="activityPage">
    <img
      src="../../../static/images/activity/activity1.png"
      mode="scaleToFill"
    />
    <img
      src="../../../static/images/activity/activity2.png"
      mode="scaleToFill"
    />
    <!-- <img
      src="../../../static/images/activity/activity3.png"
      mode="scaleToFill"
    /> -->
    <div class="rules">
      <div class="title"># 活动详情 #</div>
      <div class="item">
        <div class="title_">活动对象</div>
        <div>仅限创维轻客APP中支持银联支付的商家参与</div>
      </div>
      <div class="item">
        <div class="title_">活动内容</div>
        <div>
          活动期间，用户在创维轻客APP内使用银联支付，可享受满2元随机立减1-99元优惠。同一用户每日可享受1次、活动期间可享受10次优惠。每日名额有限，先到先得，用完即止。
        </div>
      </div>
      <div class="item">
        <div class="title_">活动细则</div>
        <div>
          1、符合同一设备、同一注册手机号、同一银行卡预留手机号、同一银行实体卡号、同一身份证号或者同一APP账号等任一条件的，均视为同一用户。用户需使用本人的电子设备、银行卡等亲自参加。
        </div>
        <div>
          2、用户支付时，如通过输入银行卡号等信息完成支付的，无法参与优惠活动。
        </div>
        <div>
          3、享受优惠的交易如发生退款、撤销等反向交易，则视为用户放弃优惠，退款金额扣除享受的优惠金额后退回至用户原付款卡。该次优惠次数视为已使用。
        </div>
        <div>
          4、由于用户电子设备不支持、APP未更新到最新版本、卡片挂失、换卡等自身原因导致无法享受优惠的，该优惠次数后续不予补发。
        </div>
        <div>
          5、为使更多的用户享到本活动优惠权益，对使用或涉嫌使用违反活动规则或不正当方式套取银联优惠的用户及其所使用的工具，包括但不限于手机号、银行卡号、APP账号等，中国银联和商户有权不予优惠、追回已发放的优惠,并拒绝其今后参加银联的任何优惠活动。
        </div>
        <div>
          6、本次活动所有时间点以中国银联后台系统时间（北京时间）为准。如出现不可抗力或情势变更等情况（如重大灾害事件、受有权机关指令需停止或调整的、系统故障需暂停的、活动中存在违规作弊行为损害消费者权益的），在法律许可的范围内，银联保留调整、暂停和终止本活动的权利，并经公告后生效。
        </div>
        <div>
          7、用户参与活动即视为理解并同意本活动细则。优惠不与商户的积分、红包、会员卡等同享，如对商品、活动规则有疑问，请咨询活动商户。
        </div>
        <div>
          8、由于网络可能存在迟延，云闪付APP活动展示券上显示的剩余名额仅供参考。
        </div>
        <div>注:所有活动及商品均与苹果公司 ( Apple Inc.)无关</div>
      </div>
    </div>
    <div class="eCodeView" v-if="wxPageType">
      <img
        src="../../../static/images/activity/activityECode.png"
        mode="scaleToFill"
        show-menu-by-longpress
      />
      <div class="tipView">
        长按识别二维码进入公众号，下载最新版本【创维轻客APP】及【云闪付APP】即可
      </div>
    </div>
    <van-button @click="openHerf" class="btnView" v-else
      >下载云闪付立享活动</van-button
    >
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      wxPageType: false
    };
  },
  created() {
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      this.wxPageType = true;
    }
  },
  mounted() {},
  methods: {
    openHerf() {
      window.open("https://youhui.95516.com/hybrid_v3/html/help/download.html");
    }
  }
};
</script>
<style lang="less" scoped>
.activityPage {
  padding: 0;
  margin: 0;
  width: 100vw;
  min-height: 100vh;
  background-color: #ce202a;
  text-align: center;
  padding-bottom: 5rem;
  img {
    width: 14rem;
  }
  .btnView {
    width: 12rem;
    font-weight: 500;
    letter-spacing: 0.15rem;
    font-size: 0.6rem;
  }
  .eCodeView {
    width: 12rem;
    margin: 0.5rem auto;
    img {
      width: 6.5rem;
      height: 6.5rem;
    }
    .tipView {
      color: #ffffff;
      margin: 0.5rem 0;
    }
  }
  .rules {
    width: 80%;
    margin: 0 auto;
    text-align: left;
    padding: 0.5rem 0.8rem;
    margin-bottom: 0.6rem;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 0.8rem;
    font-size: 0.5rem;
    .title {
      color: #ce202a;
      font-weight: bold;
      font-size: 0.7rem;
      margin-bottom: 0.7rem;
    }
    .item {
      margin-bottom: 0.8rem;
      > div {
        margin-bottom: 0.4rem;
      }
      .title_ {
        font-size: 0.6rem;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/unionpay.vue